import React from 'react';
import { Icon, IconButton, Tooltip } from '@branchjs/neo-components';
import classNames from 'classnames';
import useTableModeSwitcherService from 'client/js/main/screens/ScreenRoiHub/analytics/TableModeSwitcher/useTableModeSwitcherService';
import type { ReportActiveMode } from '../../../../../../../shared/types/roi-hub/TableModeSwitcher.types';

type TableModeSwitcherProps = {
  context: string;
  activeMode: ReportActiveMode;
  updateActiveMode: (viewMode: ReportActiveMode) => void;
};

const TableModeSwitcher = (props: TableModeSwitcherProps) => {
  const { hide, css, onTreeButtonClick, onFlatButtonClick, activeMode, disabled } = useTableModeSwitcherService(props);

  if (hide) {
    return null;
  }

  return (
    <div className={css.container}>
      <span className={css.label}>Table type:</span>
      <div className={css.buttons}>
        <Tooltip id="table-mode-switcher-tree-button-tooltip" title="Drill-down table" placement="top">
          <div role="table-mode-switcher-tree-button">
            <IconButton
              id="table-mode-switcher-tree-button"
              onClick={onTreeButtonClick}
              className={classNames(css.button, css.treeButton, {
                active: activeMode === 'tree',
              })}
              disabled={disabled}
            >
              <span className={css.treeIcon} />
            </IconButton>
          </div>
        </Tooltip>
        <Tooltip id="table-mode-switcher-flat-button-tooltip" title="Flat table" placement="top">
          <div role="table-mode-switcher-flat-button">
            <IconButton
              id="table-mode-switcher-flat-button"
              onClick={onFlatButtonClick}
              className={classNames(css.button, css.listButton, {
                active: activeMode === 'flat',
              })}
              disabled={disabled}
            >
              <Icon>list</Icon>
            </IconButton>
          </div>
        </Tooltip>
      </div>
    </div>
  );
};

export default TableModeSwitcher;
